import { SVGProps, Ref, forwardRef } from 'react';

export const BellCrossedOutlinedSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M21.466 17.654C21.288 12.977 20.045 1 11.996 1c-2.12 0-3.766.83-5.046 2.14l1.272 1.273c.994-1.025 2.207-1.614 3.773-1.614 1.848 0 3.202.817 4.287 2.2 1.132 1.445 1.928 3.474 2.463 5.673.43 1.77.668 3.555.798 5.06zM6.263 7.538c-.41.967-.746 2.03-1.014 3.134-.559 2.297-.832 4.663-.924 7.023h12.097zm-1.36-1.36C2.287 11.648 2.5 19.494 2.5 19.494h5.768c.466 1.969 1.588 3.5 3.731 3.5s3.266-1.531 3.732-3.5h2.49L21.727 23 23 21.728 2.273 1.004 1 2.276zm5.23 13.316h3.733a4 4 0 0 1-.315.751c-.356.64-.8.949-1.552.949s-1.195-.308-1.551-.949a4 4 0 0 1-.315-.75"
            fill="currentColor"
        />
    </svg>
));
BellCrossedOutlinedSize24Glyph.displayName = 'BellCrossedOutlinedSize24Glyph';
